import { MarcacionOpcionFE } from '../types';

// SPEC-206 (ADR-001) — ESPEJO en el backend: seleccionarOpcion, calcularPrecioMarcacion (sin área)
// y calcularPrecioUnitario se replican en
// cv-printing-backend/src/modules/cotizaciones/domain/ReprecioCotizacion.ts para re-preciar las
// marcaciones 'minima' y 'rango'. Cualquier cambio aquí va también allá (CA-034).

export function esTipoManual(nombreTipo: string): boolean {
  const lower = nombreTipo.toLowerCase();
  return lower.includes('laser') || lower.includes('láser') ||
    lower.includes('sublimacion') || lower.includes('sublimación');
}

/**
 * Selecciona la opción aplicable para una cantidad dada dentro de una lista de opciones
 * filtradas por categoría y tintas (si aplica).
 * RN-001: cantidad_min IS NULL → aplica si cantidad < primer tier con cantidad_min NOT NULL
 */
export function seleccionarOpcion(opciones: MarcacionOpcionFE[], cantidad: number): MarcacionOpcionFE | null {
  const tieredOpciones = opciones.filter(o => o.cantidadMin !== null);
  const minTierMin = tieredOpciones.length > 0
    ? Math.min(...tieredOpciones.map(o => o.cantidadMin!))
    : Infinity;

  const filaMinima = opciones.find(o => o.cantidadMin === null);

  if (cantidad < minTierMin && filaMinima) return filaMinima;

  const aplicable = tieredOpciones
    .filter(o => {
      const desde = o.cantidadMin!;
      const hasta = o.cantidadMax ?? Infinity;
      return cantidad >= desde && cantidad <= hasta;
    })
    .sort((a, b) => a.precio - b.precio);

  if (aplicable.length > 0) return aplicable[0];
  if (filaMinima) return filaMinima;
  return null;
}

/**
 * Calcula el precio total de marcación para una opción dada.
 * RN-002:
 *   - cantidad_min IS NULL → precio fijo
 *   - cantidad_min IS NOT NULL → precio × cantidad
 *   - por_area impresión (areaCm2 provisto) → MAX(88000, areaCm2 × precio)
 */
export function calcularPrecioMarcacion(
  opcion: MarcacionOpcionFE,
  cantidad: number,
  areaCm2?: number,
): number {
  if (areaCm2 !== undefined && areaCm2 > 0 && opcion.cantidadMin !== null) {
    if (opcion.cantidadMax !== null) {
      return Math.max(88000, areaCm2 * opcion.precio);
    }
    return areaCm2 * opcion.precio;
  }

  if (opcion.cantidadMin === null) {
    return opcion.precio;
  }

  return opcion.precio * cantidad;
}

/**
 * RN-004: el precio de marcación persistido/mostrado siempre es el valor POR UNIDAD,
 * en los cuatro esquemas (tarifa "Mínima", por rango, por área, manual/cotizado).
 * `totalCalculado` es siempre el total del trabajo completo (para toda la cantidad).
 */
export function calcularPrecioUnitario(totalCalculado: number, cantidad: number): number {
  if (cantidad <= 0) return 0;
  return Math.round(totalCalculado / cantidad);
}
